import { useEffect, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";

const ACTIVITY_LABELS: Record<string, string> = {
  badge_earned: "earned a badge",
  challenge_won: "won a challenge",
  level_up: "levelled up",
  streak_milestone: "hit a streak milestone",
};

export function LiveActivityToast() {
  const { user } = useAuth();
  const { toast } = useToast();
  const wsRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    if (!user) return;

    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const ws = new WebSocket(`${protocol}//${window.location.host}/ws`);
    wsRef.current = ws;

    ws.onopen = () => {
      ws.send(JSON.stringify({ type: "auth", userId: user.id }));
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === "feed_activity" && data.item) {
          const item = data.item;
          const label = ACTIVITY_LABELS[item.activityType];
          if (!label) return;
          const firstName = item.firstName ?? item.user?.firstName ?? "Someone";
          toast({
            title: `${firstName} just ${label}`,
            duration: 4000,
          });
        }
      } catch {
        // ignore parse errors
      }
    };

    ws.onerror = () => {
      // silently ignore WS errors: non-critical feature
    };

    return () => {
      ws.close();
      wsRef.current = null;
    };
  }, [user?.id]);

  return null;
}
